// extracted by mini-css-extract-plugin
export default {"container":"xr5Ad9tcSf"};